import { Outlet } from "react-router-dom";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { GrainOverlay, ScrollProgress } from "./Overlays";
import { ScrollToTop } from "./SmoothScroll";
import { WhatsAppButton } from "./WhatsAppButton";
import { RouteMeta } from "./RouteMeta";

export function Layout() {
  return (
    <div className="App bg-ink">
      <RouteMeta />
      <ScrollToTop />
      <ScrollProgress />
      <GrainOverlay />
      <Navbar />
      <main>
        <Outlet />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
